import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect } from 'react';
import { useProgress } from '../../common/utils/use-progress';
import { loadEnterpriseReCaptchaScript, loadFreeReCaptchaScript } from './load-recaptcha';
export { loadFreeReCaptchaScript, loadEnterpriseReCaptchaScript };

/**
 * Communicates with HAMS to determine whether ReCaptcha needs to be used for the specified operation.
 * @param operation Please see: https://hello.atlassian.net/wiki/spaces/~261604415/pages/1169536418/Hams%2BCaptcha%2BTech%2BImplementation%2BOverview?focusedCommentId=1180858296#Implementation%3A
 */
export var useReCaptchaService = function useReCaptchaService() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      locale = _ref.locale,
      _ref$loadReCaptcha = _ref.loadReCaptcha,
      loadReCaptcha = _ref$loadReCaptcha === void 0 ? loadEnterpriseReCaptchaScript : _ref$loadReCaptcha;

  var _useProgress = useProgress(),
      _useProgress2 = _slicedToArray(_useProgress, 3),
      intializeProgress = _useProgress2[0],
      setLoaded = _useProgress2[1],
      setLoading = _useProgress2[2];

  useEffect(function () {
    var stillMounted = true;

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var reCaptchaClient;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return loadReCaptcha({
                locale: locale
              });

            case 2:
              reCaptchaClient = _context.sent;

              if (stillMounted) {
                setLoaded(reCaptchaClient);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();

    return function () {
      stillMounted = false;
    };
  }, [locale, setLoaded, setLoading, loadReCaptcha]);
  return intializeProgress;
};